import React, { useState } from 'react';
import { useDeleteReservationMutation } from '../Service/reservationsApi';
import { useCreateRedirect } from '../../Shared/Hooks/useCreateRedirect';
import { ReservationsRoutes } from '../../../Router/path';
import { useDeleteSelectedItems } from '../../Shared/Hooks/useDeleteSelectedItems';
import CustomCard from '../../Shared/Components/CustomCard/CustomCard';
import InfoIcon from '@mui/icons-material/Info';

import ReservationDataTable from '../Components/ReservationDataTable/ReservationDataTable';
import { ReservationSearchFilters } from '../Types/reservationTypes';
import { reservationValuesSearch } from '../Components/ReservationSearch/initialValues';
import ReservationSearchForm from '../Components/ReservationSearch/ReservationSearchForm';

import { useReservationsData } from '../Hooks/useReservationsData';

import InfoCard from '../../Shared/Components/InfoCard/InfoCard';
import { usePagination } from '../../Shared/Hooks/usePagination';
import { useSelection } from '../../Shared/Hooks/useSelection';

const Reservations = () => {
  const [filters, setFilters] = useState<ReservationSearchFilters>(reservationValuesSearch);
  const { page, setPage, rowsPerPage, setRowsPerPage } = usePagination();
  const { selected: selectedReservationIds, setSelected, resetSelection } = useSelection<number>();

  const {
    reservationsData,
    isReservationsLoading,
    isReservationsError,
    reservationsError,
    filterSelects,
    isFilterSelectsLoading,
  } = useReservationsData(filters, page, rowsPerPage);
console.log('[ReservationsTable] params', { filters, page, rowsPerPage, reservationsData });
  const [deleteReservation] = useDeleteReservationMutation();
  const handleCreate = useCreateRedirect(ReservationsRoutes.create);

  const handleDeleteSelected = useDeleteSelectedItems<number>(
    selectedReservationIds,
    (id) => deleteReservation(id).unwrap(),
    resetSelection
  );

  return (
    <>
      <InfoCard
        icon={<InfoIcon fontSize="large" color="primary" />}
        title="Rezerwacje"
        subheader="Zarządzaj rezerwacjami w systemie"
        infoText="
          Na tej stronie zarządzasz wszystkimi dostępnymi rezerwacjami klientów w systemie.
          Możesz przeglądać listę istniejących rezerwacji wraz z podstawowymi informacjami
          (nazwa oferty, lokalizacja, status).
        "
        hintText="Skorzystaj z przycisków, aby dodać nową rezerwację lub anulować wybrane pozycje."
        onCreate={handleCreate}
        onDeleteSelected={handleDeleteSelected}
      >
        <ReservationSearchForm
          onSearch={setFilters}
          filterSelects={filterSelects}
          isLoading={isFilterSelectsLoading}
        />
      </InfoCard>
      <CustomCard>
        <ReservationDataTable
          data={reservationsData?.items || []}
          isLoading={isReservationsLoading}
          isError={isReservationsError}
          errorMessage={(reservationsError as any)?.data?.message}
          totalCount={reservationsData?.totalCount || 0}
          onSelectionChange={setSelected}
          page={page}
          rowsPerPage={rowsPerPage}
          onPageChange={setPage}
          onRowsPerPageChange={setRowsPerPage}
        />
      </CustomCard>
    </>
  );
};

export default Reservations;
